// 菜单，顶栏

import Setting from "@/setting.env.js"

export default [
    // {
    //     path: '/bcos/browser',
    //     title: 'WeBase',
    //     icon: 'md-swap',
    //     hideSider: true,
    //     name: 'WeBase'
    // },
    {
        path: Setting.MonitorUrl,
        title: 'Portainer',
        target: "_blank",
        icon: 'md-desktop',
        hideSider: false,
        name: 'monitor'
    },

];
